export const GET_MULTIPLE_QUESTIONS = 'GET_MULTIPLE_QUESTIONS';
export const EDIT_MULTIPLE_QUESTIONS = 'EDIT_MULTIPLE_QUESTIONS';
export const SUBMIT_MULTIPLE_QUESTIONS = 'SUBMIT_MULTIPLE_QUESTIONS';